export default {
    _prefix: "SettingsIndicators",
    displayConditionally: "Display Conditionally",
    includeConditionally: "Include Conditionally",
    fatalQuestion: "Fatal Question",
    criticalQuestion: "Critical Question",
    naEnabled: "N/A Enabled",
    commentsRequired: "Comments Required",
    assistanceConfigured: "Uses Evaluation Assistance",
    AiScoringConfigured: "Uses AI Scoring",
};
